import React, { useEffect, useState } from "react";
import { api, apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Copy, Mail, KeyRound, Check } from "lucide-react";

export function LateArrivalPanel({ b }) {
  const [f, setF] = useState(null);
  const [url, setUrl] = useState("");
  const [paid, setPaid] = useState(false);
  const [busy, setBusy] = useState("");
  const [tax, setTax] = useState({ rate: null, nights: 0 });
  const setAdults = (v) => {
    const n = Math.max(parseInt(v, 10) || 0, 0);
    setF({ ...f, adults: v, tourist_tax: tax.rate != null ? Math.round(tax.rate * tax.nights * n * 100) / 100 : f.tourist_tax });
  };
  const inp = "w-full rounded-lg border border-ink-400/25 px-3 py-2 text-sm text-ink-900";

  useEffect(() => {
    api.get(`/admin/bookings/${b.id}/late-link`).then((r) => {
      const rate = r.data.tax_rate;
      const ad = r.data.adultes ?? "";
      const autoTax = !r.data.url && rate != null && ad !== "" ? Math.round(rate * r.data.nights * Number(ad) * 100) / 100 : null;
      setF({ access_code: r.data.access_code || "", balance: r.data.balance ?? 0, tourist_tax: autoTax ?? r.data.tourist_tax ?? 0, adults: ad });
      setTax({ rate: r.data.tax_rate, nights: r.data.nights });
      setUrl(r.data.url || ""); setPaid(r.data.paid);
    }).catch(() => setF({ access_code: "", balance: 0, tourist_tax: 0 }));
  }, [b.id]);

  const create = async () => {
    setBusy("create");
    try {
      const r = await api.post(`/admin/bookings/${b.id}/late-link`, {
        access_code: f.access_code, balance: Number(f.balance) || 0, tourist_tax: Number(f.tourist_tax) || 0, adults: f.adults === "" ? null : Number(f.adults), origin_url: window.location.origin,
      });
      setUrl(r.data.url); toast.success("Lien d'arrivée prêt");
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(""); }
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Lien copié"); } catch (e) { toast.error("Copie impossible"); }
  };
  const send = async () => {
    setBusy("send");
    try { const r = await api.post(`/admin/bookings/${b.id}/late-link/send`, {}); toast.success(`E-mail envoyé à ${r.data.sent_to}`); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(""); }
  };

  if (!f) return null;
  const total = (Number(f.balance) || 0) + (Number(f.tourist_tax) || 0);
  return (
    <div className="rounded-xl bg-white p-4 space-y-2" data-testid="bd-late-section">
      <span className="text-xs text-ink-400 flex items-center gap-1.5"><KeyRound size={13} /> Arrivée tardive en votre absence</span>
      {paid && <p className="text-xs font-medium text-emerald-700 flex items-center gap-1" data-testid="bd-late-paid"><Check size={13} /> Réglé en ligne par le client</p>}
      <input className={inp} placeholder="Code / instructions d'accès à la chambre" value={f.access_code} onChange={(e) => setF({ ...f, access_code: e.target.value })} data-testid="bd-late-code" />
      {tax.rate != null && (
        <label className="text-[11px] text-ink-400 block">Adultes (taxe {tax.rate.toFixed(2)} € × {tax.nights} nuit{tax.nights > 1 ? "s" : ""} × adultes)
          <input type="number" min="0" className={inp} value={f.adults} onChange={(e) => setAdults(e.target.value)} data-testid="bd-late-adults" />
        </label>
      )}
      <div className="grid grid-cols-2 gap-2">
        <label className="text-[11px] text-ink-400">Solde du séjour (€)
          <input type="number" min="0" step="0.01" className={inp} value={f.balance} onChange={(e) => setF({ ...f, balance: e.target.value })} data-testid="bd-late-balance" />
        </label>
        <label className="text-[11px] text-ink-400">Taxe de séjour (€)
          <input type="number" min="0" step="0.01" className={inp} value={f.tourist_tax} onChange={(e) => setF({ ...f, tourist_tax: e.target.value })} data-testid="bd-late-tax" />
        </label>
      </div>
      <p className="text-xs text-ink-600">À régler par carte : <b data-testid="bd-late-total">{total.toFixed(2)} €</b></p>
      <button onClick={create} disabled={busy === "create"} className="w-full rounded-full bg-brand text-white py-2 text-sm font-medium hover:bg-brand-600 disabled:opacity-60" data-testid="bd-late-create">
        {busy === "create" ? "…" : url ? "Mettre à jour le lien" : "Créer le lien d'arrivée"}
      </button>
      {url && (
        <div className="space-y-2">
          <p className="text-[11px] text-ink-500 break-all" data-testid="bd-late-url">{url}</p>
          <div className="flex gap-2">
            <button onClick={copy} className="flex-1 rounded-full border border-brand text-brand py-1.5 text-xs font-medium hover:bg-brand-50 flex items-center justify-center gap-1.5" data-testid="bd-late-copy"><Copy size={13} /> Copier le lien</button>
            {b.email && <button onClick={send} disabled={busy === "send"} className="flex-1 rounded-full border border-brand text-brand py-1.5 text-xs font-medium hover:bg-brand-50 disabled:opacity-60 flex items-center justify-center gap-1.5" data-testid="bd-late-send"><Mail size={13} /> {busy === "send" ? "…" : "Envoyer par e-mail"}</button>}
          </div>
        </div>
      )}
    </div>
  );
}
